
import axios from "@/plugins/axios.js"

const actions = {
  fetchNotifications({ commit, state}, payload = {}) {
    return new Promise((resolve, reject) => {
      axios.get(`/notifications?${new URLSearchParams(payload).toString()}`)
        .then((response) => {
          if(response.data.success){
            commit('SET_NOTIFICATIONS', response.data.data)
          }
          resolve(response)
        }).catch((error) => { reject(error) })
    })
  },
  markAsRead({ commit }, itemId) {
    return new Promise((resolve, reject) => {
      axios.get(`/notifications/${itemId}/markasread`)
        .then((response) => {
          if(response.data.success){
            commit('MARK_AS_READ', itemId)
          }
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
}

const getters = {}

const mutations = {
    SET_NOTIFICATIONS(state, data) {
      state.pageData = data
    },
    ADD_NOTIFICATION(state, notification) {
        state.pageData.data.unshift(notification)
    },
    REMOVE_NOTIFICATION(state, notifId) {
        const ItemIndex = state.pageData.data.findIndex((item) => item.id == notifId)
        state.pageData.data.splice(ItemIndex, 1)
    },
    MARK_AS_READ(state, notifId){
      state.pageData.data.map((item)=>{
        if(item.id == notifId){
          return item.is_seen = 1
        }
      })
    }
}

const state = {
  pageData: {
    data: []
  },
}


export default {
  isRegistered: true,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}

